import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full h-24 md:h-32 flex rounded-lg shadow my-2 overflow-hidden" }
const _hoisted_2 = { class: "h-24 w-24 md:h-32 md:w-32 flex-none items-center flex" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "p-2 md:p-4 items-center w-full" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "px-3 rounded-full text-xs bg-primary-main text-gray-800" }
const _hoisted_7 = { class: "w-56 ml-2 text-xs mt-2 text-gray-700 text-left my-auto" }
const _hoisted_8 = {
  key: 0,
  class: "w-56 ml-2 text-xs mt-2 text-gray-700 text-left my-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.receiptImageUrl,
        class: "object-contain flex justify-center"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.statusLabel), 1)
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatedCreatedAt), 1),
      (_ctx.conditionMismatchDetails)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionMismatchDetails, (detail) => {
              return (_openBlock(), _createElementBlock("div", {
                key: detail,
                class: "list-none"
              }, [
                _createElementVNode("li", null, _toDisplayString(detail), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}